import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=c0abc932&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0abc932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0abc932')) {
      api.createRecord('c0abc932', component.options)
    } else {
      api.reload('c0abc932', component.options)
    }
    module.hot.accept("./Project.vue?vue&type=template&id=c0abc932&scoped=true&", function () {
      api.rerender('c0abc932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account/center/page/Project.vue"
export default component.exports